const baseInputStyles = (theme) => ({
  backgroundColor: 'transparent',
  fontFamily: 'var(--root-font) !important',
  fontWeight: 400,
  width: '100%'
})

const sizes = {
  xs: (theme) => ({
    padding: '2px 6px',
    minHeight: '20px',
    ...baseInputStyles(theme),
    lineHeight: '20px',
    fontSize: theme.typography.fontSizes.md
  }),
  sm: (theme) => ({
    padding: '2px 10px 2px 10px',
    minHeight: '32px',
    ...baseInputStyles(theme),
    lineHeight: '32px',
    fontSize: theme.typography.fontSizes.lg
  }),
  md: (theme) => ({
    padding: '2px 10px 2px 10px',
    minHeight: '32px',
    ...baseInputStyles(theme),
    lineHeight: '32px',
    fontSize: theme.typography.fontSizes.xl
  }),
  lg: (theme) => ({
    padding: '9px 10px 9px 15px',
    minHeight: '54px',
    ...baseInputStyles(theme),
    lineHeight: '32px',
    fontSize: theme.typography.fontSizes.xxl
  })
}

export const mapInputStyles = (theme, rest) => ({ disabled, size, minWidth }) => ({
  ...rest,
  ...sizes[size](theme),
  backgroundColor: disabled ? 'var(--color-neutral-300)' : 'var(--color-surface-050)',
  ...(minWidth && { minWidth })
})
